import { Component, EventEmitter, OnChanges, OnInit, Input, Output } from "@angular/core";
//import { PDFViewerModule } from "@progress/kendo-angular-pdfviewer";
//const pdfjs = require('pdfjs-dist');
//import { PDFWorker } from "pdfjs-dist";

@Component({
    selector: 'document-viewer',
    templateUrl: './document-viewer.component.html',
    standalone: false
})
export class DocumentViewer implements OnChanges, OnInit {
    @Input() fileName: string = "";
    @Input() fileUri: string = "";
    @Input() isWindow: boolean = true;
    @Output() onClose = new EventEmitter<any>();

    public isPDF: boolean = false;

    constructor() {
    }

    ngOnInit() {
        //if (this.fileName.toLocaleLowerCase().endsWith(".pdf")) {
        //    this.isPDF = true;
        //}
        //else {
        //    this.isPDF = false;
        //}
        //console.log("DocumentViewer:ngOnInit", this.fileName, this.fileUri, this.isPDF);
    }

    ngOnChanges() {
        if (this.fileName.toLocaleLowerCase().endsWith(".pdf")) {
            this.isPDF = true;
        }
        else {
            this.isPDF = false;
        }
        console.log("DocumentViewer:ngOnChanges", this.fileName, this.fileUri, this.isPDF);
    }

    close() {
        this.fileName = "";
        this.fileUri = "";
        this.onClose.emit();
    }
}
